import React from "react";

export default function CheckBox({
  color = "#fff",
  hideCheck = true,
  ...restProps
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      id="CheckBoxIcon"
      x="0px"
      y="0px"
      viewBox="0 0 60 60"
      style={{ enableBackground: "new 0 0 60 60" }}
      xmlSpace="preserve"
      width="512px"
      height="512px"
      {...restProps}
    >
      <g>
        {!hideCheck && (
          <path
            d="M26.375,39.781C26.559,39.928,26.78,40,27,40c0.276,0,0.551-0.114,0.748-0.336l16-18c0.367-0.412,0.33-1.045-0.083-1.411   c-0.414-0.368-1.045-0.33-1.412,0.083l-15.369,17.29l-9.259-7.407c-0.43-0.345-1.061-0.273-1.405,0.156   c-0.345,0.432-0.275,1.061,0.156,1.406L26.375,39.781z"
            fill={color}
          />
        )}
        <path d="M0,0v60h60V0H0z M58,58H2V2h56V58z" fill={color} />
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  );
}
